import {$, w} from './constants';


// - - - M e n ú   r e s p o n s i v e - - -
$(document).ready(function() {

    const btnAbrir = $(".open-menu");
    const btnCerrar = $(".close");
    const menuMobile = $(".header");
    
    
        // Abrir menu lateral
        $(document).on("click", ".open-menu", function() {
            // $("body").toggleClass("sidebar-mini");
            menuMobile.toggleClass('show-menu');
        });
    
        // Condición para cambiar el texto al hacer click en <p>Menu</p> opción MENU | CERRAR
    
        btnAbrir.click(function() {
            var current_lang = $('.nav__lenguage-esp.active').get(0);
            var close_text = 'Close';
            
            if($(current_lang).text().trim() == 'Esp'){
                close_text = 'Cerrar'
            }

            var s = $(this);
                s.html(s.text() == close_text ? 'Menu' : close_text);
        });
        // Cerrar menu lateral
        $(document).on("click", ".close", function() {
            // menuMobile.removeClass('show-menu');
            btnAbrir.html("Menu");
        });
});

// Función para obtener href del menu (Pasar estilos al elemento de la página donde se está  en curso)
$(document).ready(function() {
    $(".lista li [href]").each(function() {
		console.log(this.href);
		console.log(window.location.href.indexOf(this.href));
		// Evaluamos la condición para ver si la barra de direcciones es igual
		// la ruta del href del elemento del menu al hacer click
		// Si mi ruta tiene "practicearea" o  "lawyers " agrega esta clase
        if (window.location.href.indexOf(this.href) === 0) {

			// Si se cumple, agrega la clase
			$(this).parent().addClass("menu-active");
			// console.log($(this).parent());
        }
    });
});


// WEBPACK FOOTER //
// ./es6/menu.js